import { RootState } from 'modules/store';

const root = (state: RootState) => state.customer;

export const getSelectedCustomer = (state: RootState) => root(state).selectedCustomer;
export const getTemplateCustomer = (state: RootState) => root(state).templateCustomer;
